// extracted by mini-css-extract-plugin
module.exports = {"min-width-0":"InputGroup_min-width-0__I2bVt","flex-shrink-0":"InputGroup_flex-shrink-0__v_8WP"};